import { SystemUserRoles } from "../../../../core/helpers/user-roles.helper";
import { MenuItem } from "../../models/menu-items..models";

export const MENU_ITEMS: MenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'home',
    link: '/home',
    data: {
      permissions: SystemUserRoles.ALL,
      key: 'menu.dashboard'
    }
  },
  {
    title: 'Tickets',
    icon: 'table',
    link: '/tickets',
    data: {
      permissions: SystemUserRoles.ALL,
      key: 'menu.tickets'
    }
  },
  {
    title: 'Categories',
    icon: 'grid',
    link: '/categories',
    data: {
      permissions: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      key: 'menu.categories'
    }
  },
  {
    title: 'Projects',
    icon: 'grid',
    link: '/projects',
    data: {
      permissions: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      key: 'menu.projects'
    }
  },
  {
    title: 'Users',
    icon: 'people-circle',
    link: '/users',
    data: {
      permissions: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      key: 'menu.users'
    }
  },
  {
    title: 'Priorities',
    icon: 'people-circle',
    link: '/priorities',
    data: {
      permissions: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      key: 'menu.priorities'
    }
  },
  {
    title: 'Chat History',
    icon: 'people-circle',
    link: '/chat/history',
    data: {
      permissions: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      key: 'menu.chatHistory'
    }
  }
];


